export const HealLocations = [
  {
    name: 'LACA',
    address: '11845 W Olympic Blvd Suite 900, Sawtelle, Los Angeles, CA',
    position: {
      lat: 34.0333727,
      lng: -118.4542063,
    },
  },
  {
    name: 'SF/SV',
    address: '133 Arch Street #3, Redwood City, CA',
    position: {
      lat: 37.4878945,
      lng: -122.24008,
    },
  },
  {
    name: 'OC',
    address: '2050 W Chapman Ave Ste 287, Orange, CA',
    position: {
      lat: 33.7876179,
      lng: -117.8773779,
    },
  },
  {
    name: 'SD',
    address: '3940 Hancock Street #104, San Diego, CA',
    position: {
      lat: 32.7576048,
      lng: -117.21869,
    },
  },
  {
    name: 'WA',
    address: '748 Market St, Tacoma, WA',
    position: {
      lat: 47.2558348,
      lng: -122.4447833,
    },
  },
  {
    name: 'DC',
    address: '1250 Connecticut Ave NW Suite 700, D.C., DC',
    position: {
      lat: 38.9070156,
      lng: -77.0443944,
    },
  },
  {
    name: 'ATL',
    address: '275 Carpenter Dr NE Unit 310, Atlanta, GA',
    position: {
      lat: 33.9151355,
      lng: -84.3801318,
    },
  },
  {
    name: 'NY',
    address: '36-36 33rd St Ste. 306, Long Island City, NY',
    position: {
      lat: 40.7549007,
      lng: -73.9313823,
    },
  },
  {
    name: 'NJ',
    address: '162 Elmora Avenue Suite 304, Elizabeth, NJ',
    position: {
      lat: 40.6626154,
      lng: -74.2359408,
    },
  },
  {
    name: 'SK',
    address: '7115 N Division St Suite B #168, Spokane, WA',
    position: {
      lat: 47.7231057,
      lng: -117.4140841,
    },
  },
];
